import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${theme.colors.blue900};

  display: grid;
  grid-template-columns: 0.2fr 0.8fr;
  grid-template-rows: 1fr;
  grid-template-areas:
    "sidebar header"
    "sidebar main";

  @media screen and (max-width: 768px) {
    width: 100vw;
    display: flex;
    flex-direction: column;
  }
`;

export const Header = styled.header`
  grid-area: header;
  width: 100%;
  padding: 20px;
  height: 10vh;
  background-color: ${theme.colors.blue900};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px 0px 16px 16px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
`;

export const Main = styled.div`
  grid-area: main;
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 89vh;
  padding: 0 16px;
  overflow: hidden;
  background-color: ${theme.colors.blue900};

  @media screen and (max-width: 768px) {
    height: 90vh;
  }
`;
